import React from  'react'
import {IMaskInput} from "react-imask";

export const MaskedInput = React.forwardRef(function MaskedInput(props, ref) {
    const {onChange, mask, lazy = false, placeholderChar = ' ', ...other} = props;
    return (
        <IMaskInput
            {...other}
            mask={mask || ''}
            lazy={lazy}
            placeholderChar={placeholderChar}
            inputRef={ref}
            onAccept={(value) => {
                if(onChange) {
                    onChange( { target: {name:  name, value } });
                }
            }}
            overwrite
       />
    );
});